// The prototype's icon set (Edge Portal design, index_updated.html): ICONS are 24-unit stroke paths;
// LINE_ART (brand line icons, filled dots) wins when both exist, exactly like the prototype's icon().
// Stroke 1.6, currentColor. Generated from the prototype; edit both maps there first.
import type { ReactElement } from "react";

const PATHS = {
  arrowRight: "M5 12h14 M13 6l6 6-6 6",
  award:
    "M6 9a6 6 0 1 0 12 0 6 6 0 1 0-12 0 M12 15l3.4 5.89 1.6-3.23 3.6.23-3.4-5.89 M6.8 12l-3.4 5.89 3.6-.23 1.6 3.23 3.4-5.89",
  bookmark: "M18 7v14l-6-4-6 4V7a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4z",
  briefcase:
    "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
  building: "M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16 M15 9h4a1 1 0 0 1 1 1v11 M3 21h18 M8 8h3 M8 12h3 M8 16h3",
  calCheck: "M11.5 21H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6 M16 3v4 M8 3v4 M4 11h16 M15 19l2 2 4-4",
  calendar: "M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z M16 3v4 M8 3v4 M4 11h16",
  card: "M3 8a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z M3 10h18",
  chat: "M21 14l-3-3h-7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v10 M14 15v2a1 1 0 0 1-1 1H6l-3 3V11a1 1 0 0 1 1-1h2",
  check: "M5 12l5 5L20 7",
  chevDown: "M6 9l6 6 6-6",
  chevRight: "M9 6l6 6-6 6",
  chevsLeft: "M11 7l-5 5 5 5 M17 7l-5 5 5 5",
  clock: "M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0 M12 7v5l3 3",
  coffee: "M4 9h12v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5z M16 11h1.5a2.5 2.5 0 0 1 0 5H16 M8 3v3 M12 3v3",
  download: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2 M7 11l5 5 5-5 M12 4v12",
  edit: "M4 20h4L18.5 9.5a2.83 2.83 0 1 0-4-4L4 16v4 M13.5 6.5l4 4",
  feedback: "M4 4h16v12H9l-5 4z M12 7v6 M9 10h6",
  filter: "M4 4h16v2.17a2 2 0 0 1-.59 1.42L15 12v7l-6 2v-8.5L4.52 7.57A2 2 0 0 1 4 6.23z",
  globe:
    "M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0 M3.6 9h16.8 M3.6 15h16.8 M11.5 3a17 17 0 0 0 0 18 M12.5 3a17 17 0 0 1 0 18",
  groups:
    "M10 13a2 2 0 1 0 4 0 2 2 0 0 0-4 0 M8 21v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1 M15 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0 M17 10h2a2 2 0 0 1 2 2v1 M5 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0 M3 13v-1a2 2 0 0 1 2-2h2",
  help: "M3 12a9 9 0 1 0 18 0 9 9 0 1 0-18 0 M12 17v.01 M12 13.5a1.5 1.5 0 0 1 1-1.5 2.6 2.6 0 1 0-3-4",
  history: "M12 8v4l2 2 M3.05 11a9 9 0 1 1 .5 4 M3 20v-5h5",
  home: "M5 12H3l9-9 9 9h-2 M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7 M9 21v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6",
  language: "M4 5h7 M9 3v2c0 4.42-2.24 8-5 8 M5 9c0 2.14 2.95 3.91 6.7 4 M12 20l4-9 4 9 M19.1 18h-6.2",
  lock: "M6 11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z M8.5 10V7.5a3.5 3.5 0 0 1 7 0V10",
  mail: "M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M3 7l9 6 9-6",
  mic: "M9 5a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0z M5 10a7 7 0 0 0 14 0 M8 21h8 M12 17v4",
  monitor: "M3 5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z M8 20h8 M12 16v4",
  payroll:
    "M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M14 9.5c-.4-.6-1.1-1-2-1-1.1 0-2 .7-2 1.5s.9 1.3 2 1.5 2 .7 2 1.5-.9 1.5-2 1.5c-.9 0-1.6-.4-2-1 M12 7.5v1 M12 15.5v1",
  phone: "M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2",
  pin: "M9 11a3 3 0 1 0 6 0 3 3 0 0 0-6 0 M17.66 16.66l-4.25 4.24a2 2 0 0 1-2.83 0l-4.24-4.24a8 8 0 1 1 11.32 0z",
  plane:
    "M14.64 10.26l4.83-1.3a2 2 0 1 1 1.04 3.87L6.02 16.71l-4.45-5.02 2.9-.78 2.45 1.42 2.9-.78-3.75-6.24 2.9-.78 5.67 5.73z M3 21h18",
  school: "M22 9L12 5 2 9l10 4 10-4v6 M6 10.6V16a6 3 0 0 0 12 0v-5.4",
  search: "M3 10a7 7 0 1 0 14 0 7 7 0 1 0-14 0 M21 21l-6-6",
  settings:
    "M10.33 4.32c.43-1.76 2.92-1.76 3.35 0a1.72 1.72 0 0 0 2.57 1.07c1.54-.94 3.31.83 2.37 2.37a1.72 1.72 0 0 0 1.07 2.57c1.76.43 1.76 2.92 0 3.35a1.72 1.72 0 0 0-1.07 2.57c.94 1.54-.83 3.31-2.37 2.37a1.72 1.72 0 0 0-2.57 1.07c-.43 1.76-2.92 1.76-3.35 0a1.72 1.72 0 0 0-2.57-1.07c-1.54.94-3.31-.83-2.37-2.37a1.72 1.72 0 0 0-1.07-2.57c-1.76-.43-1.76-2.92 0-3.35a1.72 1.72 0 0 0 1.07-2.57c-.94-1.54.83-3.31 2.37-2.37 1 .61 2.3.07 2.57-1.07z M9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0",
  shield: "M12 3a12 12 0 0 0 8.5 3A12 12 0 0 1 12 21 12 12 0 0 1 3.5 6 12 12 0 0 0 12 3 M9 12l2 2 4-4",
  sparkle: "M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z",
  userCircle:
    "M3 12a9 9 0 1 0 18 0 9 9 0 1 0-18 0 M9 10a3 3 0 1 0 6 0 3 3 0 1 0-6 0 M6.17 18.85A4 4 0 0 1 10 16h4a4 4 0 0 1 3.83 2.86",
  userPlus: "M8 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0 M16 19h6 M19 16v6 M6 21v-2a4 4 0 0 1 4-4h4",
  users:
    "M5 7a4 4 0 1 0 8 0 4 4 0 1 0-8 0 M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2 M16 3.13a4 4 0 0 1 0 7.75 M21 21v-2a4 4 0 0 0-3-3.85",
  video:
    "M15 10l4.55-2.28A1 1 0 0 1 21 8.62v6.76a1 1 0 0 1-1.45.9L15 14z M3 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
  volume:
    "M15 8a5 5 0 0 1 0 8 M17.7 5a9 9 0 0 1 0 14 M6 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2l3.5-4.5A.8.8 0 0 1 11 5v14a.8.8 0 0 1-1.5.5L6 15",
  x: "M18 6L6 18 M6 6l12 12",
} as const;

type Shape = ["path" | "circle" | "rect" | "ellipse", Record<string, string | number>, boolean];

const LINE_ART: Record<string, Shape[]> = {
  chat: [
    ["path", { d: "M4.4 7.2h10.4a1.6 1.6 0 0 1 1.6 1.6v4.8a1.6 1.6 0 0 1-1.6 1.6H8.4l-2.8 2.4v-2.4H4.4Z" }, false],
    ["circle", { cx: 8.0, cy: 11.2, r: ".6" }, true],
    ["circle", { cx: 10.4, cy: 11.2, r: ".6" }, true],
    ["circle", { cx: 12.8, cy: 11.2, r: ".6" }, true],
  ],
  clock: [
    ["circle", { cx: 12.0, cy: 12.0, r: 7.2 }, false],
    ["path", { d: "M12 5.6v.8M12 17.6v.8M5.6 12h.8M17.6 12h.8" }, false],
    ["path", { d: "M12 7.6V12l3.6 1.6" }, false],
  ],
  globe: [
    ["circle", { cx: 12.0, cy: 12.0, r: 7.6 }, false],
    ["ellipse", { cx: 12.0, cy: 12.0, rx: 3.2, ry: 7.6 }, false],
    ["path", { d: "M4.4 12h15.2" }, false],
    ["path", { d: "M5.2 8.4Q12 10.4 18.8 8.4" }, false],
    ["path", { d: "M5.2 15.6Q12 13.6 18.8 15.6" }, false],
  ],
  gradCap: [
    ["path", { d: "M3.6 9.6L12 5.6l8.4 4-8.4 4Z" }, false],
    ["path", { d: "M7.2 11.6v3.6c0 1.3 2.2 2.4 4.8 2.4s4.8-1.1 4.8-2.4v-3.6" }, false],
    ["path", { d: "M20.4 9.6v4" }, false],
    ["circle", { cx: 20.4, cy: 15.4, r: ".7" }, true],
  ],
  headset: [
    ["path", { d: "M5.6 13.2v-1.6a6.4 6.4 0 0 1 12.8 0v1.6" }, false],
    ["rect", { x: 4.4, y: 12.4, width: 3.2, height: 4.8, rx: 1.2 }, false],
    ["rect", { x: 16.4, y: 12.4, width: 3.2, height: 4.8, rx: 1.2 }, false],
    ["path", { d: "M18 17.2v.4a2.4 2.4 0 0 1-2.4 2.4h-2" }, false],
    ["circle", { cx: 12.4, cy: 20.0, r: ".7" }, true],
  ],
  lock: [
    ["rect", { x: 5.6, y: 10.8, width: 12.8, height: 9.2, rx: 1.2 }, false],
    ["path", { d: "M8 10.8V8a4 4 0 0 1 8 0v2.8" }, false],
    ["circle", { cx: 12.0, cy: 14.8, r: ".7" }, true],
    ["path", { d: "M12 14.8v2.4" }, false],
  ],
  magnifyCheck: [
    ["circle", { cx: 10.8, cy: 10.8, r: 5.6 }, false],
    ["path", { d: "M15 15l4.4 4.4" }, false],
    ["path", { d: "M8.4 10.8l1.6 1.6 3-3.2" }, false],
  ],
  shield: [
    ["path", { d: "M12 3.2l6.8 2.4v6c0 4.4-3 7.2-6.8 9.2-3.8-2-6.8-4.8-6.8-9.2v-6Z" }, false],
    ["path", { d: "M8.8 12.4l2.4 2.4 4.4-5.2" }, false],
  ],
  shieldPlain: [["path", { d: "M12 3.2l6.8 2.4v6c0 4.4-3 7.2-6.8 9.2-3.8-2-6.8-4.8-6.8-9.2v-6Z" }, false]],
  success: [
    ["circle", { cx: 12.0, cy: 12.0, r: 7.2 }, false],
    ["path", { d: "M8.8 12l2.4 2.4 4.4-5.2" }, false],
  ],
  swap: [
    ["path", { d: "M5.6 9.2h12.4l-3.2-3.2" }, false],
    ["path", { d: "M18.4 14.8H6l3.2 3.2" }, false],
  ],
  // The How it works popup's Did you find this helpful? (prototype LINE_ART thumbUp, thumbDown)
  thumbUp: [
    ["path", { d: "M8 10.8L8 19.2" }, false],
    ["path", { d: "M5.76 10.8H8L10.72 5.28Q11.36 4.72 12.24 4.88Q13.84 5.28 13.6 7.04L13.12 10H17.28Q19.04 10.08 18.8 11.92L17.76 18.08Q17.52 19.2 16.32 19.2H5.76Q4.8 19.2 4.8 18.24V11.76Q4.8 10.8 5.76 10.8Z" }, false],
  ],
  thumbDown: [
    ["path", { d: "M8 13.2L8 4.8" }, false],
    ["path", { d: "M5.76 13.2H8L10.72 18.72Q11.36 19.28 12.24 19.12Q13.84 18.72 13.6 16.96L13.12 14H17.28Q19.04 13.92 18.8 12.08L17.76 5.92Q17.52 4.8 16.32 4.8H5.76Q4.8 4.8 4.8 5.76V12.24Q4.8 13.2 5.76 13.2Z" }, false],
  ],
  // Empty-state bullets and the meeting confirmation (prototype index_last_day.html LINE_ART)
  receipt: [
    ["path", { d: "M6.4 4h11.2v16l-2.2-1.4-2.2 1.4-2.2-1.4-2.2 1.4-2.4-1.4Z" }, false],
    ["path", { d: "M9.2 8.4h5.6M9.2 11.6h5.6M9.2 14.8h3.2" }, false],
  ],
  trendUp: [
    ["path", { d: "M4.4 16l4.8-4.8 3.2 3.2 6.4-6.4" }, false],
    ["path", { d: "M14.4 8h4.4v4.4" }, false],
    ["path", { d: "M4.4 19.6h15.2" }, false],
  ],
  docDown: [
    ["path", { d: "M7.2 4h6.4l3.2 3.2V20H7.2Z" }, false],
    ["path", { d: "M13.6 4v3.2h3.2" }, false],
    ["path", { d: "M12 10.4v6" }, false],
    ["path", { d: "M9.6 14l2.4 2.4 2.4-2.4" }, false],
  ],
  listItems: [
    ["circle", { cx: 6, cy: 7.6, r: ".8" }, true],
    ["circle", { cx: 6, cy: 12, r: ".8" }, true],
    ["circle", { cx: 6, cy: 16.4, r: ".8" }, true],
    ["path", { d: "M9.2 7.6h9.2M9.2 12h9.2M9.2 16.4h6" }, false],
  ],
  archive: [
    ["rect", { x: 4.4, y: 5.2, width: 15.2, height: 4, rx: 1 }, false],
    ["path", { d: "M5.6 9.2v8.4a1.2 1.2 0 0 0 1.2 1.2h10.4a1.2 1.2 0 0 0 1.2-1.2V9.2" }, false],
    ["path", { d: "M10 12.4h4" }, false],
  ],
  inbox: [
    ["path", { d: "M4.4 13.2l2.4-7.2h10.4l2.4 7.2v5.2a1.2 1.2 0 0 1-1.2 1.2H5.6a1.2 1.2 0 0 1-1.2-1.2Z" }, false],
    ["path", { d: "M4.4 13.2h4l1.2 2h4.8l1.2-2h4" }, false],
  ],
  pie: [
    ["circle", { cx: 12, cy: 12, r: 7.6 }, false],
    ["path", { d: "M12 4.4V12h7.6" }, false],
  ],
  calDays: [
    ["rect", { x: 4.4, y: 5.6, width: 15.2, height: 14, rx: 1.2 }, false],
    ["path", { d: "M4.4 9.6h15.2M8.4 4v3.2M15.6 4v3.2" }, false],
    ["circle", { cx: 8.4, cy: 13.2, r: ".7" }, true],
    ["circle", { cx: 12, cy: 13.2, r: ".7" }, true],
    ["circle", { cx: 15.6, cy: 13.2, r: ".7" }, true],
    ["circle", { cx: 8.4, cy: 16.4, r: ".7" }, true],
    ["circle", { cx: 12, cy: 16.4, r: ".7" }, true],
  ],
  calTick: [
    ["rect", { x: 4.4, y: 5.6, width: 15.2, height: 14, rx: 1.2 }, false],
    ["path", { d: "M4.4 9.6h15.2M8.4 4v3.2M15.6 4v3.2" }, false],
    ["path", { d: "M9.2 14.4l2 2 3.6-4" }, false],
  ],
  mobileCheck: [
    ["rect", { x: 7.2, y: 3.6, width: 9.6, height: 16.8, rx: 1.6 }, false],
    ["path", { d: "M10 11.2l1.6 1.6 2.8-3.2" }, false],
    ["circle", { cx: 12, cy: 17.6, r: ".7" }, true],
  ],
  contract: [
    ["path", { d: "M7.2 4h6.4l3.2 3.2V20H7.2Z" }, false],
    ["path", { d: "M13.6 4v3.2h3.2" }, false],
    ["path", { d: "M9.6 10.4h4.8M9.6 13.2h4.8" }, false],
    ["path", { d: "M9.6 17.2q.9-1.6 1.8 0t1.8 0 1.6 0" }, false],
  ],
  ribbon: [
    ["circle", { cx: 12, cy: 9.6, r: 4.8 }, false],
    ["path", { d: "M9.2 13.6l-1.6 6.4 4.4-2 4.4 2-1.6-6.4" }, false],
    ["circle", { cx: 12, cy: 9.6, r: ".8" }, true],
  ],
  folder: [
    ["path", { d: "M4.4 7.2a1.2 1.2 0 0 1 1.2-1.2h4l1.6 2h7.2a1.2 1.2 0 0 1 1.2 1.2v8.4a1.2 1.2 0 0 1-1.2 1.2H5.6a1.2 1.2 0 0 1-1.2-1.2Z" }, false],
    ["path", { d: "M4.4 10.4h15.2" }, false],
  ],
  info: [
    ["circle", { cx: 12, cy: 12, r: 7.6 }, false],
    ["path", { d: "M12 11.2v4.8" }, false],
    ["circle", { cx: 12, cy: 8.4, r: ".8" }, true],
  ],
  sync: [
    ["path", { d: "M18.4 10.4A6.6 6.6 0 0 0 6.4 8.4" }, false],
    ["path", { d: "M6 5.2v3.6h3.6" }, false],
    ["path", { d: "M5.6 13.6a6.6 6.6 0 0 0 12 2" }, false],
    ["path", { d: "M18 18.8v-3.6h-3.6" }, false],
  ],
  target: [
    ["circle", { cx: 12, cy: 12, r: 7.6 }, false],
    ["circle", { cx: 12, cy: 12, r: 4.4 }, false],
    ["circle", { cx: 12, cy: 12, r: 1.2 }, true],
  ],
  timeline: [
    ["path", { d: "M4.4 12a7.6 7.6 0 1 0 2.2-5.4" }, false],
    ["path", { d: "M4.8 4v3.2H8" }, false],
    ["path", { d: "M12 8.4V12l2.8 1.6" }, false],
  ],
  userCircle: [
    ["circle", { cx: 12.0, cy: 8.8, r: 2.8 }, false],
    ["path", { d: "M6 20c0-3.2 2.8-5.6 6-5.6s6 2.4 6 5.6" }, false],
    ["circle", { cx: 16.8, cy: 7.2, r: ".8" }, true],
  ],
};

export type PlgIconName =
  | keyof typeof PATHS
  | "gradCap"
  | "magnifyCheck"
  | "headset"
  | "swap"
  | "shieldPlain"
  | "success"
  | "thumbUp"
  | "thumbDown"
  | "receipt"
  | "trendUp"
  | "docDown"
  | "listItems"
  | "archive"
  | "inbox"
  | "pie"
  | "calDays"
  | "calTick"
  | "mobileCheck"
  | "contract"
  | "ribbon"
  | "folder"
  | "info"
  | "sync"
  | "target"
  | "timeline";

interface PlgIconProps {
  name: PlgIconName;
  size?: number;
  className?: string;
  /** The prototype bumps a few icons (e.g. How Edge works items) to 1.8. */
  strokeWidth?: number;
}

const TAGS = { path: "path", circle: "circle", rect: "rect", ellipse: "ellipse" } as const;

function PlgIcon({ name, size = 18, className, strokeWidth = 1.6 }: PlgIconProps): ReactElement {
  const art = LINE_ART[name];
  return (
    <svg
      className={className}
      data-icon={name}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {art ? (
        art.map(([tag, attrs, dot], i) => {
          const Tag = TAGS[tag];
          // eslint-disable-next-line react/no-array-index-key
          return <Tag key={i} {...attrs} {...(dot ? { fill: "currentColor", stroke: "none" } : {})} />;
        })
      ) : (
        <path d={PATHS[name as keyof typeof PATHS]} />
      )}
    </svg>
  );
}

export default PlgIcon;
